
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericAnchoredOutlined as ObiVesselGenericAnchoredOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-anchored-outlined.js';
 
 
 

 
 export const ObiVesselGenericAnchoredOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-anchored-outlined',
   elementClass: ObiVesselGenericAnchoredOutlinedElement,
   events: {
     
   }
  });
 
 